// src/components/customer/biddingCard/BiddingCard.jsx
import { useContext } from "react";
import AppContext from "../../../context/AppContext";
import React from "react";
import { Trophy, Clock, MapPin, Users, Eye, Timer } from "lucide-react";
import "../../../assets/css/customer/biddingCard/BiddingCard.css";



// const FALLBACK_IMAGE = FURNITURE_IMAGES[0];

const getImageForId = (id) => {
  const num = parseInt(String(id).replace(/\D/g, "")) || 0;
  // return FURNITURE_IMAGES[num % FURNITURE_IMAGES.length];
};

const BiddingCard = ({ bidding, onView, viewMode = "grid", isWinning = false, userBid = null }) => {

  const { baseUrlForFile } = useContext(AppContext);
  const getTimeRemaining = () => {
    const now = new Date();
    const end = new Date(bidding.endDate);
    const diff = end - now;
    if (diff <= 0) return "Ended";
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    if (days > 0) return `${days}d ${hours}h left`;
    if (hours > 0) return `${hours}h ${minutes}m left`;
    return `${minutes}m left`;
  };

  const isEndingSoon = () => {
    const now = new Date();
    const end = new Date(bidding.endDate);
    const hoursLeft = (end - now) / (1000 * 60 * 60);
    return hoursLeft > 0 && hoursLeft < 24;
  };

  const formatPrice = (price) =>
    new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 0,
    }).format(price);

  const timeRemaining = getTimeRemaining();
  const endingSoon = isEndingSoon();
  const productImage =
  bidding.adcustomerbidsimage &&
  bidding.adcustomerbidsimage.length > 0
    ? `${baseUrlForFile}${bidding.adcustomerbidsimage[0].bidImages}`
    : "";
    console.log("Images:", bidding.adcustomerbidsimage);
console.log("Image URL:", productImage);

  return (
    <div
      className={`bidcard-container ${viewMode === "list" ? "bidcard-list-mode" : ""}`}
      onClick={() => onView(bidding)}
    >
      {isWinning && (
        <div className="bidcard-winning-badge">
          <Trophy size={13} />
          You're Winning!
        </div>
      )}

      {endingSoon && !isWinning && (
        <div className="bidcard-ending-badge">
          <Clock size={13} />
          Ending Soon
        </div>
      )}

      <div className="bidcard-image-section">
        <img
          src={productImage}
          alt={bidding.productName}
          className="bidcard-image"
          onError={(e) => {
            e.target.onerror = null;
            // e.target.src = FALLBACK_IMAGE;
          }}
        />
        {bidding.adcustomerbidsimage?.length > 1 && (
          <div className="bidcard-image-count">
            +{bidding.adcustomerbidsimage.length - 1}
          </div>
        )}
        <div className="bidcard-condition-badge">{bidding.condition}</div>
      </div>

      <div className="bidcard-content">
        <div className="bidcard-header">
          <h3 className="bidcard-title">{bidding.productName}</h3>
          <span className="bidcard-category">{bidding.category}</span>
        </div>

        <p className="bidcard-description">{bidding.description}</p>

        <div className="bidcard-location">
          <MapPin size={14} className="bidcard-location-icon" />
          {bidding.location}
        </div>

        <div className="bidcard-price-section">
          <div className="bidcard-current-bid">
            <span className="bidcard-price-label">Current Bid</span>
            <span className="bidcard-price-value">
              {formatPrice(bidding.currentBid)}
            </span>
          </div>
          <div className="bidcard-starting-price">
            <span className="bidcard-starting-label">Starting</span>
            <span className="bidcard-starting-value">
              {formatPrice(bidding.startingPrice)}
            </span>
          </div>
        </div>

        <div className="bidcard-stats">
          <div className="bidcard-stat">
            <Users size={14} className="bidcard-stat-icon" />
            <span className="bidcard-stat-text">{bidding.totalBids} bids</span>
          </div>
          <div className="bidcard-stat">
            <Eye size={14} className="bidcard-stat-icon" />
            <span className="bidcard-stat-text">{bidding.views} views</span>
          </div>
        </div>

        <div className="bidcard-footer">
          <div className={`bidcard-time-left ${endingSoon ? "ending-soon" : ""}`}>
            <Timer size={14} className="bidcard-time-icon" />
            <span className="bidcard-time-text">{timeRemaining}</span>
          </div>
          {userBid && !isWinning && (
            <div className="bidcard-your-bid">
              Your bid: {formatPrice(userBid.amount)}
            </div>
          )}
        </div>

        <div className="bidcard-seller-info">
          <span className="bidcard-seller-label">Seller:</span>
          <span className="bidcard-seller-name">{bidding.sellerName}</span>
        </div>

        <button className="bidcard-view-btn">View Details</button>
      </div>
    </div>
  );
};

export default BiddingCard;